import React from 'react';
import PropTypes from 'prop-types';

export const Copy = ({ width, height, ...props }) => (
  <svg
    data-icon='copy'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M9 18c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 7 16V4c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 9 2h9c.55 0 1.02.196 1.413.587C19.803 2.98 20 3.45 20 4v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 18 18H9Zm0-2h9V4H9v12Zm-4 6c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V6h2v14h11v2H5Z'
    />
  </svg>
);

Copy.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Copy.defaultProps = {
  width: 24,
  height: 24,
};
